/**
 * Hospitalization-related constants shared between backend and frontend
 */

export type HospitalizationActionTypes = 'admitted' | 'discharged';

export const FOLLOW_UP_SURVEY_KEY = 'hospitalization-follow-up';
export const FOLLOWUP_HEDIS_MEASURES = ['FUA', 'FUM', 'FUH'];
export const FOLLOWUP_DATE_QUESTION_KEY = 'expected-completion-date';
export const BH_APPOINTMENT_SURVEY_KEY = 'connection-to-bh-care';

/** Days after admit/discharge for hospitalization follow-up eligibility. */
export const HOSPITALIZATION_FOLLOW_UP_ELIGIBILITY_DAYS = 30;

/** SNOMED code for Avon follow-up notes linked to phone calls. */
export const HOSPITALIZATION_FOLLOW_UP_SNOMED_CODE = '386473003';

/** SNOMED code for Avon follow-up notes linked to in-person visits. */
export const HOSPITALIZATION_FOLLOW_UP_IN_PERSON_SNOMED_CODE = '439708006';
